import { render, staticRenderFns } from "./footerSocial.vue?vue&type=template&id=31bef083&scoped=true&lang=pug&"
import script from "./footerSocial.vue?vue&type=script&lang=ts&"
export * from "./footerSocial.vue?vue&type=script&lang=ts&"
import style0 from "./footerSocial.vue?vue&type=style&index=0&id=31bef083&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bef083",
  null
  
)

export default component.exports